import type { PrimaryToolbarPluginOptions } from '@atlaskit/editor-plugin-primary-toolbar';

interface Props {
	options: never;
}

export function primaryToolbarPluginOptions({}: Props): PrimaryToolbarPluginOptions {
	return { contextualFormattingEnabled: true };
}
